import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseWizardSearch } from '@/modules/leasing/wizard-helpers';

const LeasingWizard = lazy(() =>
  import('@/modules/leasing/LeasingWizard').then((m) => ({ default: m.LeasingWizard })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/wizard',
  component: () => (
    <Suspense fallback={null}>
      <LeasingWizard />
    </Suspense>
  ),
  validateSearch: parseWizardSearch,
});
